import React, { useState } from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CTABlock } from './CTABlock';
import { Lock, Smartphone, ShieldCheck, Crown, Leaf } from 'lucide-react';
export function OfferStack() {
  const [selected, setSelected] = useState<'combo' | 'base'>('combo');
  return <section id="cart" className="bg-white py-20 px-4" data-id="element-133">
      <div className="max-w-2xl mx-auto" data-id="element-134">
        <div className="rounded-3xl shadow-xl overflow-hidden border border-chocolate-800/10" data-id="element-135">
          {/* Header */}
          <div className="bg-chocolate-900 text-gold-400 p-5 flex items-center justify-center gap-3" data-id="element-136">
            <Crown className="w-6 h-6" data-id="element-137" />
            <h3 className="text-xl md:text-2xl font-bold tracking-wide" data-id="element-138">
              RESUMEN DE VALOR
            </h3>
          </div>

          <div className="bg-chocolate-50 p-5 md:p-8" data-id="element-139">
            {/* Selectable Combo Cards */}
            <div className="space-y-4 mb-8" data-id="element-140">
              {/* Combo Pro - First */}
              <button onClick={() => setSelected('combo')} className={`w-full text-left bg-chocolate-900 text-chocolate-50 rounded-2xl p-6 transition-all duration-200 relative ${selected === 'combo' ? 'border-2 border-gold-500 shadow-xl' : 'border-2 border-chocolate-800/30 opacity-80'}`} data-id="element-141">
                {/* Radio indicator */}
                <div className="absolute top-6 right-6" data-id="element-142">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'combo' ? 'border-gold-400 bg-gold-400' : 'border-chocolate-50/40'}`} data-id="element-143">
                    {selected === 'combo' && <div className="w-2.5 h-2.5 rounded-full bg-chocolate-900" data-id="element-144"></div>}
                  </div>
                </div>

                <div className="pr-10" data-id="element-145">
                  <div className="inline-block bg-gold-500 text-chocolate-900 text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-146">
                    ⭐ MÁS ELEGIDO
                  </div>
                  <div className="flex items-center gap-2 mb-2" data-id="element-147">
                    <Leaf className="w-5 h-5 text-gold-400" data-id="element-148" />
                    <h3 className="text-xl font-bold" data-id="element-149">COMBO PRO</h3>
                  </div>
                  <div className="inline-block bg-solution/20 text-solution text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-150">
                    AHORRÁS <PriceDisplay amount={7910} data-id="element-151" />
                  </div>
                  <p className="font-bold text-chocolate-50/70 text-sm mb-4" data-id="element-152">
                    5 Tomos + 5 Bonos + Protocolo Día Blindado + Plan 21 días
                  </p>
                  <div className="flex items-baseline gap-3" data-id="element-153">
                    <span className="text-chocolate-50/40 line-through font-bold" data-id="element-154">
                      <PriceDisplay amount={56500} data-id="element-155" />
                    </span>
                    <span className="text-3xl font-bold text-white" data-id="element-156">
                      <PriceDisplay amount={29990} data-id="element-157" />
                    </span>
                  </div>
                </div>
              </button>

              {/* Pack Base - Second */}
              <button onClick={() => setSelected('base')} className={`w-full text-left bg-chocolate-900 text-chocolate-50 rounded-2xl p-6 transition-all duration-200 relative ${selected === 'base' ? 'border-2 border-gold-500 shadow-xl' : 'border-2 border-chocolate-800/30 opacity-80'}`} data-id="element-158">
                {/* Radio indicator */}
                <div className="absolute top-6 right-6" data-id="element-159">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'base' ? 'border-gold-400 bg-gold-400' : 'border-chocolate-50/40'}`} data-id="element-160">
                    {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-chocolate-900" data-id="element-161"></div>}
                  </div>
                </div>

                <div className="pr-10" data-id="element-162">
                  <div className="flex items-center gap-2 mb-2" data-id="element-163">
                    <Leaf className="w-5 h-5 text-gold-400" data-id="element-164" />
                    <h3 className="text-xl font-bold" data-id="element-165">PACK BASE</h3>
                  </div>
                  <p className="font-bold text-chocolate-50/70 text-sm mb-4" data-id="element-166">
                    5 Tomos + 5 Bonos | 500+ páginas
                  </p>
                  <div className="flex items-baseline gap-3" data-id="element-167">
                    <span className="text-chocolate-50/40 line-through font-bold" data-id="element-168">
                      <PriceDisplay amount={37900} data-id="element-169" />
                    </span>
                    <span className="text-3xl font-bold text-white" data-id="element-170">
                      <PriceDisplay amount={19990} data-id="element-171" />
                    </span>
                  </div>
                </div>
              </button>
            </div>

            {/* Value Summary */}
            <div className="space-y-3 mb-8 pt-4 border-t border-chocolate-800/10" data-id="element-172">
              <div className="flex justify-between items-center text-chocolate-800 pb-3 border-b border-chocolate-800/10" data-id="element-173">
                <span className="font-bold" data-id="element-174">5 Tomos Método Antídoto Dulce</span>
                <span className="font-bold" data-id="element-175">
                  <PriceDisplay amount={26950} data-id="element-176" />
                </span>
              </div>
              <div className="flex justify-between items-center text-chocolate-800 pb-3 border-b border-chocolate-800/10" data-id="element-177">
                <span className="font-bold" data-id="element-178">5 Bonos Exclusivos</span>
                <span className="font-bold" data-id="element-179">
                  <PriceDisplay amount={10950} data-id="element-180" />
                </span>
              </div>
              {selected === 'combo' && <div className="flex justify-between items-center text-chocolate-800 pb-3 border-b border-chocolate-800/10" data-id="element-181">
                  <span className="font-bold" data-id="element-182">Protocolo Día Blindado</span>
                  <span className="font-bold text-gold-500" data-id="element-183">INCLUIDO</span>
                </div>}
              <div className="flex justify-between items-center pt-2" data-id="element-184">
                <span className="text-lg font-bold text-chocolate-900" data-id="element-185">
                  VALOR TOTAL
                </span>
                <span className="text-lg font-bold text-chocolate-800/60 line-through" data-id="element-186">
                  <PriceDisplay amount={selected === 'combo' ? 56500 : 37900} data-id="element-187" />
                </span>
              </div>
              <div className="flex justify-between items-center bg-gold-400/20 p-4 rounded-xl" data-id="element-188">
                <span className="text-lg font-bold text-chocolate-900" data-id="element-189">
                  🔥 HOY PAGÁS SOLO
                </span>
                <span className="text-2xl font-bold text-pain" data-id="element-190">
                  <PriceDisplay amount={selected === 'combo' ? 29990 : 19990} data-id="element-191" />
                </span>
              </div>
            </div>

            {/* Single CTA */}
            <CTABlock href={selected === 'combo' ? 'https://checkout.tumundoglobal.online/cart/45312167182527:1' : 'https://checkout.tumundoglobal.online/cart/45312098271423:1'} className="w-full text-lg md:text-xl" data-id="element-192">
              {selected === 'combo' ? '⭐ ' : ''}ACCEDER AHORA —{' '}
              <PriceDisplay amount={selected === 'combo' ? 29990 : 19990} data-id="element-193" />
            </CTABlock>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-chocolate-800 font-medium mt-6" data-id="element-194">
              <div className="flex items-center gap-1.5" data-id="element-195">
                <Lock className="w-4 h-4 text-gold-500" data-id="element-196" />
                <span data-id="element-197">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-198">
                <Smartphone className="w-4 h-4 text-gold-500" data-id="element-199" />
                <span data-id="element-200">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-201">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-202" />
                <span data-id="element-203">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}